export enum BenefitTypes {
    Generic = 'Generic',
    MedicalPlan = 'MedicalPlan',
    OnlineDoctor = 'OnlineDoctor'
}
